import { render, staticRenderFns } from "./ContactAgenda.vue?vue&type=template&id=c4a1b2b2&scoped=true&"
import script from "./ContactAgenda.vue?vue&type=script&lang=ts&"
export * from "./ContactAgenda.vue?vue&type=script&lang=ts&"
import style0 from "./ContactAgenda.vue?vue&type=style&index=0&id=c4a1b2b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a1b2b2",
  null
  
)

export default component.exports